module.exports = __webpack_public_path__ + "static/media/LYCA.afb20788.svg";